import { useMutation } from '@tanstack/react-query';

import { type components, createNaturalParty } from 'wg-api-sdk';

import wgApi from '@/lib/api/wgApi';

type CreateNaturalPartyValues = Omit<
  components['schemas']['CustomerCreateCmd'],
  'documents' | 'claims' | 'links' | 'risk_objects' | 'type'
>;

export default function useCreateNaturalParty() {
  return useMutation({
    mutationFn: (values: CreateNaturalPartyValues) =>
      createNaturalParty(
        {
          body: {
            ...values,
            type: 'CUSTOMER',
            documents: [],
            claims: [],
            links: [],
            risk_objects: {
              cars: [],
              residences: [],
              families: [],
              two_wheelers: [],
              teachers: [],
              legal: [],
              party_groups: [],
              boats: [],
              miscellanea: [],
              trailers: [],
              semi_trailers: [],
              fleets: [],
              bicycles: [],
            },
          },
        },
        wgApi,
      ),
  });
}
